import React from "react";
import { HelpCircle } from "lucide-react";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";
import { PARAM_HELP } from "@/lib/help";

/** Tiny `?` icon next to a label that pops a HoverCard with parameter docs. */
export default function ParamHelp({ paramKey, side = "right" }) {
  const doc = PARAM_HELP[paramKey];
  if (!doc) return null;
  return (
    <HoverCard openDelay={150} closeDelay={100}>
      <HoverCardTrigger asChild>
        <button
          type="button"
          data-testid={`param-help-${paramKey}`}
          aria-label={`Help: ${doc.title}`}
          className="inline-flex w-4 h-4 items-center justify-center rounded-full text-muted-foreground hover:text-primary transition-colors"
        >
          <HelpCircle className="w-3.5 h-3.5" strokeWidth={2} />
        </button>
      </HoverCardTrigger>
      <HoverCardContent
        side={side}
        align="start"
        className="w-80 bg-card border border-border text-foreground p-4 shadow-xl"
      >
        <div className="font-mono text-[10px] uppercase tracking-widest text-primary mb-1.5">
          {doc.title}
        </div>
        {doc.text && (
          <p className="text-xs text-foreground/85 leading-relaxed">
            {doc.text}
          </p>
        )}
        {doc.items && (
          <dl className="mt-2 space-y-1.5">
            {doc.items.map(([k, v]) => (
              <div key={k}>
                <dt className="text-xs font-semibold text-foreground">{k}</dt>
                <dd className="text-xs text-muted-foreground leading-snug">{v}</dd>
              </div>
            ))}
          </dl>
        )}
      </HoverCardContent>
    </HoverCard>
  );
}
